var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUbuntu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512px",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    viewBox: "0 0 512 512",
    width: "512px",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x33_48-ubuntu"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,26.001c-127.057,0-230,102.943-230,229.999c0,127.057,102.943,229.999,230,229.999    c127.056,0,229.999-102.942,229.999-229.999C485.999,128.944,383.057,26.001,256,26.001z",
    style: {
      fill: "#E14715"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.873,112.251c8.164-14.097,26.248-19.012,40.344-10.851    c14.189,8.162,19.013,26.245,10.852,40.436c-8.161,14.097-26.247,19.011-40.343,10.851    C301.536,144.433,296.714,126.348,304.873,112.251z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.057,285.585c-16.323,0-29.584-13.264-29.584-29.585c0-16.322,13.261-29.585,29.584-29.585    s29.584,13.263,29.584,29.585C136.641,272.321,123.38,285.585,107.057,285.585z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.118,288.462c20.681-16.604,20.774-48.134,0-64.828c7.975-30.42,26.988-56.295,52.399-73.359    L207.497,187c-47.762,33.665-47.762,104.335,0,138.001l-21.98,36.725C160.105,344.754,141.186,318.787,133.118,288.462z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.217,410.602c-14.188,8.16-32.18,3.337-40.344-10.853    c-8.159-14.188-3.337-32.272,10.853-40.435c14.096-8.161,32.182-3.339,40.343,10.852    C364.229,384.355,359.406,402.44,345.217,410.602z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.495,346.146c-24.761-9.552-52.027,6.12-56.108,32.458c-4.823,1.3-45.351,13.264-89.681-8.717    l20.867-37.375c52.863,24.577,114.442-10.851,119.544-69l42.753,0.649C380.737,296.155,366.827,324.907,345.495,346.146    L345.495,346.146z",
    style: {
      fill: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.023,248.488c-5.009-57.5-66.125-93.854-119.543-68.999l-20.868-37.375    c44.423-21.979,84.858-10.017,89.682-8.719c4.08,26.246,31.346,42.013,56.108,32.46c21.424,21.237,35.241,49.987,37.281,82.076    L340.023,248.488L340.023,248.488z",
    style: {
      fill: "#FFFFFF"
    }
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUbuntu);
export default __webpack_public_path__ + "static/media/ubuntu.fc3f493f4565ceeff46932871980a705.svg";
export { ForwardRef as ReactComponent };